<template>
  <vx-card title="Популярность разделов бота">
    <vue-apex-charts
      v-if="series[0].data.length > 0"
      class="mt-6 mb-8"
      type="bar"
      @updated="fixTrimLabels"
      :series="series"
      :options="chartOptions"/>
    <div v-else>Нет данных</div>
  </vx-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  props: {
    scenario: {
      required: true,
      type: Array
    }
  },

  components: {
    VueApexCharts
  },

  data () {
    return {
      series: [
        {
          name: 'Количество переходов',
          data: []
        }
      ],

      chartOptions: {
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: false
            }
          }
        },
        chart: {
          type: 'bar',
          toolbar: {
            show: true,
            tools: {
              download: true
            }
          }
        },
        plotOptions: {
          bar: {
            endingShape: 'rounded',
            horizontal: true,
            barHeight: '70%',
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 100,
                  color: '#34a4fc'
                }
              ]
            }
          }
        },
        dataLabels: {
          enabled: true,
          position: 'left'
        },
        labels: []
      }
    }
  },

  methods: {
    // Fix trim labels in bars
    fixTrimLabels () {
      const $tspans = Array.from(document.querySelectorAll('.apexcharts-yaxis tspan'))
      $tspans.forEach($tspan => {
        let text = $tspan.textContent
        if (text.match(/\.\.\.$/)) {
          text = text.replace('...', '').trim()
          text = `${text}...`
          $tspan.innerHTML = text
        }
      })
    }
  },

  created () {
    this.scenario.forEach(item => {
      if (item.counter) {
        this.series[0].data.push(item.counter)
      }

      if (item.title) {
        this.chartOptions.labels.push(item.title)
      }
    })
  },

  mounted () {
    this.fixTrimLabels()
  }
}
</script>

<style lang="scss">
  .apexcharts-menu {
    width: 120px;
  }

  .apexcharts-menu-item {
    &.exportSVG {
      display: none;
    }
  }
</style>
